import React from 'react'

const SecondaryButton = ({ buttonText, styles, onClick }) => {
  return (
    <button className={`text-300 ${styles} transition-all duration-300 ease-in-out p-[3px] hover:text-black rounded-md `} onClick={onClick}>{buttonText} <span className=''>{`>`}</span></button>
  )
}

export default SecondaryButton